var map = {
	"./Version (6) - Ultimate Map_00.jpg": 968,
	"./Version (6) - Ultimate Map_01.jpg": 969,
	"./Version (6) - Ultimate Map_02.jpg": 970,
	"./Version (6) - Ultimate Map_03.jpg": 971,
	"./Version (6) - Ultimate Map_04.jpg": 972,
	"./Version (6) - Ultimate Map_05.jpg": 973,
	"./Version (6) - Ultimate Map_06.jpg": 974,
	"./Version (6) - Ultimate Map_07.jpg": 975,
	"./Version (6) - Ultimate Map_08.jpg": 976,
	"./Version (6) - Ultimate Map_09.jpg": 977,
	"./Version (6) - Ultimate Map_10.jpg": 978,
	"./Version (6) - Ultimate Map_11.jpg": 979,
	"./Version (6) - Ultimate Map_12.jpg": 980,
	"./Version (6) - Ultimate Map_13.jpg": 981,
	"./Version (6) - Ultimate Map_14.jpg": 982,
	"./Version (6) - Ultimate Map_15.jpg": 983,
	"./Version (6) - Ultimate Map_16.jpg": 984,
	"./Version (6) - Ultimate Map_17.jpg": 985,
	"./Version (6) - Ultimate Map_18.jpg": 986,
	"./Version (6) - Ultimate Map_19.jpg": 987,
	"./Version (6) - Ultimate Map_20.jpg": 988,
	"./Version (6) - Ultimate Map_21.jpg": 989,
	"./Version (6) - Ultimate Map_22.jpg": 990,
	"./Version (6) - Ultimate Map_23.jpg": 991,
	"./Version (6) - Ultimate Map_24.jpg": 992,
	"./Version (6) - Ultimate Map_25.jpg": 993,
	"./Version (6) - Ultimate Map_26.jpg": 994,
	"./Version (6) - Ultimate Map_27.jpg": 995,
	"./Version (6) - Ultimate Map_28.jpg": 996,
	"./Version (6) - Ultimate Map_29.jpg": 997,
	"./Version (6) - Ultimate Map_30.jpg": 998,
	"./Version (6) - Ultimate Map_31.jpg": 999,
	"./Version (6) - Ultimate Map_32.jpg": 1000,
	"./Version (6) - Ultimate Map_33.jpg": 1001,
	"./Version (6) - Ultimate Map_34.jpg": 1002,
	"./Version (6) - Ultimate Map_35.jpg": 1003,
	"./Version (6) - Ultimate Map_36.jpg": 1004
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 967;